import axios, { AxiosPromise } from 'axios';
import { IDepartment } from '../../../@types/model/masterData/department/department';
import { IDepartmentUpsert } from '../../../@types/model/masterData/department/departmentUpsert';


export default class DepartmentHttpService {
    public static getDepartmentData() : AxiosPromise<Array<IDepartment>> {
        return axios.get(`${API_URL}/v1/Department/GetAllWeb`);
    }

    public static addOrUpdateDepartment(upsert : IDepartmentUpsert) : AxiosPromise<IDepartment> {
        return axios.post(`${API_URL}/v1/Department/PostDepartment`, upsert);
    }

    public static deleteDepartment(departmentId : number) : AxiosPromise<IDepartment> {
        return axios.delete(`${API_URL}/v1/Department/Delete`, {
            params : { departmentId },
        });
    }
}
